import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// redux
import { raiseToast } from '../toast/toast';

// apis
import { getBuyerRateContracts } from '../../../api/buyerRateContracts'

export const fetchBuyerRateContract = createAsyncThunk('buyer/getBuyerRateContract', async (params, { dispatch }) => {
    const response = await getBuyerRateContracts(params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: response.data.error, detail: 'Invalid text', life: 3000}))
        throw Error()
    }
    console.log("getBuyerRateContracts response", response)
    return response.data

})

export const buyerRateContractSlice = createSlice({
    name : "buyer/getBuyerRateContract",
    initialState : {
        loading: false,
        buyerRateContractData: [],
        paginationParams : {
            pageNo: 1,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true,
            sortBy: "updatedAt",
            sortOrder: "DESC"
        },
        searchParams: {
            searchBy: "all",
            searchText: "",
            statusId: 1,
            include: [{ model: "CompanyBranches" }, { model: "CompanyERPCodeMap" }]
        },
        searchOptions: []
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updateBuyerRateContractData: (state, action) => {
            state.buyerRateContractData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchBuyerRateContract.fulfilled, (state, action) => {
                state.loading = false 
                state.buyerRateContractData = action.payload.data
                state.paginationParams.pageNo = action.payload?.pageNo-1
                state.paginationParams.recordsPerPage = action.payload?.recordsPerPage 
                if(action.payload?.totalRecords || action.payload?.totalRecords === 0){
                    state.paginationParams.totalRecords =  action.payload?.totalRecords
                    state.paginationParams.excessPagesFound = false
                }
                if(action.payload.excessPagesFound || !action.payload.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.excessPagesFound
                    }else if(action.payload.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
            }
        )
        .addCase(
            fetchBuyerRateContract.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchBuyerRateContract.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions, updateBuyerRateContractData } = buyerRateContractSlice.actions

export default buyerRateContractSlice.reducer